import AddReceptionPeriodical from './AddReceptionPeriodical.jsx';

export {
  AddReceptionPeriodical
};



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/add-reception-periodical/index.js